export function canReapplyServiceStatus(serviceStatus) {
	return [2, 3, 7].indexOf(Number(serviceStatus)) !== -1
}

export function canReapplyAfterSale(orderStatus, serviceStatus) {
	var orderOk = [4, 8, 10].indexOf(Number(orderStatus)) !== -1
	return orderOk && canReapplyServiceStatus(serviceStatus)
}

export function parseTimeMs(value) {
	if (value === null || value === undefined || value === '') {
		return 0
	}
	if (typeof value === 'number') {
		return value < 1e12 ? value * 1000 : value
	}
	var s = String(value).trim()
	if (/^\d+$/.test(s)) {
		var n = Number(s)
		return n < 1e12 ? n * 1000 : n
	}
	var t = Date.parse(s.replace(/-/g, '/'))
	return isNaN(t) ? 0 : t
}

export function isOrderOver90Days(createTime) {
	var t = parseTimeMs(createTime)
	if (!t) {
		return false
	}
	return (Date.now() - t) > 90 * 24 * 60 * 60 * 1000
}

export function getOrderCreateTime(order) {
	if (!order) {
		return ''
	}
	return order.create_time || order.create_time_str || ''
}

export function apiErrorMsg(res, fallback) {
	if (res && res.data) {
		return res.data.message || res.data.msg || fallback || '操作失败'
	}
	return fallback || '操作失败'
}

export function isServiceStatusAbnormal(msg) {
	return String(msg || '').indexOf('售后状态异常') !== -1
}

export function supportsFreeReturn(shop) {
	if (!shop) {
		return false
	}
	var rate = shop.free_return_rate
	if (rate === null || rate === undefined || rate === '') {
		return false
	}
	var n = Number(rate)
	if (!isNaN(n)) {
		return n > 0
	}
	var matched = String(rate).match(/(\d+)/)
	return matched ? Number(matched[1]) > 0 : false
}



// WEBPACK FOOTER //
// ./src/libraries/utils/afterSale.js